// extracted by mini-css-extract-plugin
module.exports = {"toast":"SuccessToast_toast__j4XCG","fadeInOut":"SuccessToast_fadeInOut__sxPdi","success":"SuccessToast_success__tgmF7","error":"SuccessToast_error__59XY2"};